import { lazy } from "react";

/**
 * Section type -> component, found automatically: the *Section.js file in each
 * section folder. Each one is its own download, fetched the first time a page
 * shows that section type, so a store only loads the sections its theme uses.
 */
const context = require.context("./", true, /^\.\/[a-z0-9_]+\/[A-Za-z]+Section\.js$/, "lazy");

const loaders = {};
context.keys().forEach((key) => {
  loaders[key.split("/")[1]] = () => context(key);
});

export const SECTION_COMPONENTS = Object.keys(loaders).reduce((map, type) => {
  map[type] = lazy(loaders[type]);
  return map;
}, {});

/**
 * Starts downloading section code before a page renders it, e.g. as soon as
 * the active theme is known. Safe to call more than once.
 */
export function preloadSections(types = []) {
  [...new Set(types)].forEach((type) => {
    if (loaders[type]) loaders[type]().catch(() => {});
  });
}
